<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute">
        <img class="box-img" src="../assets/banner.png" />
        <div class="box-font">政策法规</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px">
      <div style="display: flex; margin-top: 40px">
        <!-- <div> -->
        <!-- <div style="width: 304px; height: 400px;background: #FFFFFF;border: 1px solid #CCCCCC;">
          <ul class="u-nav-ywdt" style="padding-left:30px;">
              <li  v-for="item in down_typelist" :key="item.Id" style="float: left;" >
                <div class="lmenu" :id="item.Id" >
                  <a @click="tableshow(item)"  :title="item.Word_Text" :style="(Id == item.Id) ?'color: #DF3E3E;':''">{{ item.Word_Text }}</a>
                  <img src="../assets/about_nav.png" style="width: 26px;height: 13px;" v-show="Id == item.Id"/>
                </div>
                <div class="frame-border" :style="(Id == item.Id) ?'border: 1px solid #DF3E3E;':''" ></div>         
              </li>               
          </ul>
        </div> -->
        <!--登录-->
        <leftlogin :formData.sync="form"></leftlogin>
        <!-- </div> -->
        <div class="ml-border">
          <el-table
            :data="this.downloadlist"
            height="750"
            style="width: 100%; font-size: 18px; padding-left: 20px"
            :row-style="{}"
            :cell-style="{ 'font-size': '16px', padding: '20px 0px' }"
            :header-row-style="{}"
            :fit="true"
          >
            <el-table-column prop="Title" label="标题" width="750">
              <template slot-scope="scope">
                <router-link
                  :to="'/Policydetail?id=' + scope.row.Id"
                  style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden"
                  >{{ scope.row.Title }}</router-link
                >
              </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="发布时间" width="190" align="center">
              <template slot-scope="scope">
                {{ scope.row.CreateTime | f_date }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 15, 20]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </article>
  </div>
</template>
<script>
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "Policy",
  components: { leftlogin },
  data: function () {
    return {
      Id: 0,
      Category: 0,
      down_typelist: [],
      downloadlist: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      form: {
        name: "",
        pass: "",
        type: "",
      },
    };
  },
  updated() {},
  created() {
    this.getData();
  },
  filters: {
    f_date(dateString) {
      // 创建一个新的Date对象
      var date = new Date(dateString);

      // 确保date对象有效
      if (isNaN(date.getTime())) {
        return "Invalid Date";
      }

      // 使用getFullYear, getMonth (注意月份是从0开始的，所以需要+1), getDate方法来获取年、月、日
      // 然后使用字符串拼接来构造新的日期字符串
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2); // 保证月份总是两位数
      var day = ("0" + date.getDate()).slice(-2); // 保证日期总是两位数

      // 返回新的日期字符串
      return `${year}-${month}-${day}`;
    },
  },
  watch: {
    $route: async function (to, from) {},
  },
  mounted() {},
  methods: {
    getData() {
      var that = this;
      var params = {
        PageIndex: that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: "p.CreateTime desc",
      };
      this.$api.get("/Policy/Get", params, (r) => {
        that.downloadlist = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(size) {
      console.log(size, "size");
      this.pagesize = size;
      this.getData();
    },
    handleCurrentChange(currentPage) {
      console.log(currentPage, "currentPage");
      this.currentPage = currentPage;
      this.getData();
    },
    tableshow(item) {
      var that = this;
      that.Id = item.Id;
      that.Category = item.Word_Value;
      that.getData();
      return false;
    },
  },
  computed: {},
};
</script>

<style>
.ml-border {
  margin-left: 20px;
  height: 750px;
  border: 1px solid #cccccc;
}
.frame-border {
  width: 204px;
  border: 1px solid #eeeeee;
}
.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}
.pagination {
  text-align: center;
  margin-top: 10px;
}
</style>
